import type { PopoverContentProps as ChakraPopoverContentProps } from '@chakra-ui/react';
import { PopoverContent as ChakraPopoverContent } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export type PopoverContentProps = OmitChakraProps<
  ChakraPopoverContentProps,
  'motionProps'
>;

export const PopoverContent = withChakraAs<PopoverContentProps, 'section'>(
  (props) => {
    return <ChakraPopoverContent {...props} />;
  },
);
